import { Injectable } from '@angular/core';
import { Cloudinary } from '@cloudinary/url-gen';
import { fill } from '@cloudinary/url-gen/actions/resize';

@Injectable({
  providedIn: 'root',
})
export class CloudinaryService {
  private cloudinaryInstance: Cloudinary;

  constructor() {
    this.cloudinaryInstance = new Cloudinary({
      cloud: {
        cloudName: 'identibase',
      },
      url: {
        secure: true,
      },
    });
  }

  /**
   * Get Cloudinary image URL with customizable width, height, and default image
   * @param petImageId - The Cloudinary image ID
   * @param width - Width of the image
   * @param height - Height of the image
   * @param defaultImageUrl - The default image URL to use if petImageId is falsy
   * @returns The image URL
   */
  public getImageUrl(
    petImageId: string | null,
    width: number,
    height: number,
    defaultImageUrl: string | null
  ): string {
    if (petImageId) {
      const cloudinaryImage = this.cloudinaryInstance.image(petImageId);
      return cloudinaryImage
        .resize(fill().width(width).height(height).gravity('face'))
        .toURL();
    }

    return defaultImageUrl;
  }

  /**
   * Get Cloudinary image URL with a specific transformation
   * @param imageId - Image ID
   * @param transformation - The transformation string to apply (optional)
   * @returns The transformed or plain image URL
   */
  public getImageUrlWithTransformation(
    imageId: string | null,
    transformation?: string
  ): string | null {

    let cloudinaryImage = null;

    if (imageId) {
      cloudinaryImage = this.cloudinaryInstance.image(imageId);
    }
    if (transformation) {
      return cloudinaryImage.addTransformation(transformation).toURL();
    } else {
      return cloudinaryImage.toURL();
    }
  }
}
